var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Building, Infrastructure / Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5833 3.5H18.6666C18.3445 3.5 18.0833 3.76117 18.0833 4.08333V4.15206L22.1666 7.41873V4.08333C22.1666 3.76117 21.9055 3.5 21.5833 3.5Z",
    fill: "#47BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5417 11.0833C12.5417 10.2779 13.1947 9.625 14 9.625C14.8055 9.625 15.4584 10.2779 15.4584 11.0833C15.4584 11.8888 14.8055 12.5417 14 12.5417C13.1947 12.5417 12.5417 11.8888 12.5417 11.0833Z",
    fill: "#47BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2083 12.7872L25.1201 13.5166C25.4975 13.8185 26.048 13.7573 26.35 13.3799C26.6518 13.0026 26.5906 12.4519 26.2132 12.15L16.733 4.56588C15.1353 3.28761 12.8648 3.28761 11.267 4.56588L1.78674 12.15C1.40938 12.4519 1.3482 13.0026 1.65009 13.3799C1.95196 13.7573 2.50259 13.8185 2.87995 13.5166L3.79168 12.7872V24.7917H2.33335C1.85009 24.7917 1.45835 25.1834 1.45835 25.6667C1.45835 26.1499 1.85009 26.5417 2.33335 26.5417H25.6666C26.1499 26.5417 26.5416 26.1499 26.5416 25.6667C26.5416 25.1834 26.1499 24.7917 25.6666 24.7917H24.2083V12.7872ZM10.7917 11.0833C10.7917 9.31141 12.228 7.87499 14 7.87499C15.7719 7.87499 17.2083 9.31141 17.2083 11.0833C17.2083 12.8553 15.7719 14.2917 14 14.2917C12.228 14.2917 10.7917 12.8553 10.7917 11.0833ZM14.0576 15.4583C14.8333 15.4583 15.5016 15.4582 16.0369 15.5302C16.6104 15.6073 17.1602 15.7813 17.6061 16.2272C18.0522 16.6732 18.226 17.2229 18.3031 17.7966C18.3705 18.2982 18.3747 18.917 18.375 19.6315C18.375 19.6792 18.375 19.7273 18.375 19.7757V24.7917H16.625V19.8333C16.625 18.9836 16.6231 18.4344 16.5687 18.0297C16.5178 17.6501 16.4354 17.5313 16.3688 17.4646C16.3022 17.398 16.1832 17.3157 15.8036 17.2646C15.3989 17.2102 14.8497 17.2083 14 17.2083C13.1503 17.2083 12.601 17.2102 12.1964 17.2646C11.8169 17.3157 11.6979 17.398 11.6313 17.4646C11.5647 17.5313 11.4823 17.6501 11.4313 18.0297C11.3769 18.4344 11.375 18.9836 11.375 19.8333V24.7917H9.62501V19.7757C9.62497 19.0001 9.62493 18.3317 9.69688 17.7966C9.774 17.2229 9.9479 16.6732 10.3939 16.2272C10.8398 15.7813 11.3896 15.6073 11.9632 15.5302C12.4984 15.4582 13.1667 15.4583 13.9425 15.4583H14.0576Z",
    fill: "#47BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5417 11.0833C12.5417 10.2779 13.1947 9.625 14 9.625C14.8055 9.625 15.4584 10.2779 15.4584 11.0833C15.4584 11.8888 14.8055 12.5417 14 12.5417C13.1947 12.5417 12.5417 11.8888 12.5417 11.0833Z",
    fill: "#47BDFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlue);
export default __webpack_public_path__ + "static/media/home_blue.85d411adf769fcc877d1d4b7fe8b9c63.svg";
export { ForwardRef as ReactComponent };